var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"white--text"},[_vm._v("\n    Your In-Time for "+_vm._s(_vm.today)+" is "+_vm._s(_vm.inTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }